import type { Integer } from "@pdfking/tfunc"

export type Pointer = Integer<"Pointer", "u32">
